<template>
  <v-card class="how-it-works-header elevation-11">
    <div
      class="title"
      v-for="(title, index) in titles"
      @click="changeTab(index)"
    >
      <div class="title-text" :class="{ active: getActiveTab(index) }">
        {{ title }}
      </div>
      <transition name="slide-fade">
        <div v-if="getActiveTab(index)" class="active-tab"></div>
      </transition>
    </div>
  </v-card>
</template>

<script>
  export default {
    name: 'Tabs',
    components: {},
    props: {
      titles: {
        required: true,
        default: [],
        type: Array,
      },
      activeTab: {
        required: true,
        default: 0,
        type: Number,
      },
    },
    methods: {
      changeTab(index) {
        this.$emit('tabSelected', index);
      },
      getActiveTab(index) {
        return this.activeTab === index;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .how-it-works-header {
    * {
      font-family: Montserrat, Gill Sans, Gill Sans MT, Calibri, Trebuchet MS,
        sans-serif !important;
    }
    display: flex;
    justify-content: space-evenly;
    height: 60px;
    max-width: 928px;
    width: 100%;
    .title {
      flex: 1;
      gap: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;

      .title-text {
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        text-align: center;
        color: #747474;

        &.active {
          font-weight: 600;
          color: #282828;
        }
      }
    }
  }

  .active-tab {
    background: linear-gradient(
      96.35deg,
      #00c0e8 5%,
      #4768ea 43.91%,
      #ed0080 95%
    ) !important;
    height: 4px;
    transition: position 0.3s ease;
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: transform 0.333s ease, opacity 0.333s ease;
  }

  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(0);
    opacity: 0;
  }
</style>
